import { SiteDto } from "api/generated/namecheck"

export const getTagColor = (isActive?: boolean): string => {
  return isActive ? "green" : "red"
}

export const getSiteTagColor = (site?: SiteDto): string => {
  return "geekblue"
}
